'use strict';

import {fnToastrFormError, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnTogglePayslipsSent = function () {

    let tableName = '#datatable-salary-status';

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    if (!element_exists(tableName)) return false;

    let btnApprove = '.btn_payslips_sent_to_payroll_system';

    let lang = allLangFiles['pay-slips'].toggle_sent;

    $(document).off('click', btnApprove);
    $(document).on('click', btnApprove, function (e) {
        e.preventDefault();
        let url = $(this).data('href');
        let isManualApproval = $(this).data('manualApproval');

        let confirmText = lang.confirm;

        if (isManualApproval) {
            confirmText += '<br>' + lang.warning;
        }

        $.confirm({
            title: lang.title,
            content: confirmText,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            url: url,
                            success: function (response) {
                                printResponse(response);
                                $(tableName).DataTable().ajax.reload(null, false);
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });
    });
};
